<template>
    <section class="py-16">
        <div class="mx-auto container">
            <h2 class="text-5xl text-dim_dark mb-12">
                Почему мы?
            </h2>
            <div class="grid grid-cols-3 gap-6">
                <div class="col-span-1">
                    <div class="w-full h-full bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/dist/hero-slider-5.png?57b7f91c46bc47d231a44e4ba8a9eadc')] relative">
                    <div class="h-[140px] w-[140px] border-t-2 border-s-2 border-solid border-dim_regular absolute -left-2 -top-2"></div></div>
                </div>
                <div class="col-span-1">
                    <div class="px-12 flex justify-center items-center h-[200px] rounded border border-solid border-dim_gold_2 hover:bg-dim_gold_2 transition-all">
                        <p class="text-2xl text-dim_dark text-center">
                            Высококачественная <br> защита от затопления
                        </p>
                    </div>
                </div>
                <div class="col-span-1">
                    <div class="px-12 flex justify-center items-center h-[200px] rounded border border-solid border-dim_gold_2 hover:bg-dim_gold_2 transition-all">
                        <p class="text-2xl text-dim_dark text-center">
                            Высококачественная <br> защита от затопления
                        </p>
                    </div>
                </div>
                <div class="col-span-1">
                    <div class="px-12 flex justify-center items-center h-[200px] rounded border border-solid border-dim_gold_2 hover:bg-dim_gold_2 transition-all">
                        <p class="text-2xl text-dim_dark text-center">
                            Почти полное отсутствие <br>
                            необходимого ухода <br>
                            за потолком
                        </p>
                    </div>
                </div>
                <div class="col-span-1">
                    <div class="px-12 flex justify-center items-center h-[200px] rounded border border-solid border-dim_gold_2 hover:bg-dim_gold_2 transition-all">
                        <p class="text-2xl text-dim_dark text-center">
                            Большой ассортимент <br>
                            фактур, цветовых гамм  <br>
                            и рисунков
                        </p>
                    </div>
                </div>
                <div class="col-span-1">
                    <div class="w-full h-full bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/dist/hero-slider-5.png?57b7f91c46bc47d231a44e4ba8a9eadc')] relative">
                    <div class="h-[140px] w-[140px] border-b-2 border-e-2 border-solid border-dim_regular absolute -right-2 -bottom-2"></div>
                    </div>
                    
                </div>
                <div class="col-span-3 text-center">
                    <button class="col-start-2 px-20 rounded py-4 text-xl text-black bg-dim_gold_2 border border-solid border-dim_gold_2 hover:border-black hover:bg-transparent mt-8">
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>